import React from 'react'
import { useData } from 'vike-react/useData'

import type { Data } from './+data'
import { BlogIndexLayout } from './Layout'

export default function BlogIndexPage() {
  const { blogPosts } = useData<Data>()
  return <BlogIndexLayout selectedCategory="all" blogPosts={blogPosts} />
}
